<template>
<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <a class="navbar-brand proswitch" @click="showversion($event)"><img src="../assets/newprosw.png" width=120 height=30></a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Action
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <slot name="action"/>
          </ul>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown2" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Control
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown2">
            <slot name="screen"/>
          </ul>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown99" 
              role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Monitor
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown99">
            <slot name="monitor"/>
          </ul>
        </li>

        <slot name="report"/>
      </ul>

      <span class="navbar-text d-none d-lg-block alignright2">
          CURRENT SWAP: {{current_swap}}
      </span>
        <li class="nav-item dropdown alignright2">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
            <li v-for="item in swaplist" :key=item.name>
               <a class="dropdown-item" @click="changeswap(item.pswline)">{{item.name}} - {{item.pswline}}</a>
            </li>
          </ul>
        </li>

        <li class="nav-item dropdown alignright2">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                USER: {{userlogin}}
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
               <li> <a class="dropdown-item" @click.prevent="logout" role="button"> Logout </a></li>
               <li> <a class="dropdown-item" @click="show_modalpwd($event)" role="button"> Chg Passwd</a></li>
          </ul>
        </li>
    </div>
  </div>
  <!-- <a class="nav-link" v-if="!$store.state.email" to="/login">Login</a> -->
</nav>
<ShowVersion ref="MODALV01" modalid="MODALV01" />
<ChgPasswd ref="MChgPasswd01" modalid="MChgPasswd01" :userid="this.$store.state.email">
   <div style='margin:auto;width:50%'>
     <br>
     <button style='padding:2px' type="button" data-bs-dismiss="modal" 
              @click="changepwd()">Change</button>
   </div>
</ChgPasswd>
</template>

<script>
import ChgPasswd from './ChgPasswd.vue' 
import ShowVersion from './ShowVersion.vue' 
import bootstrap from 'bootstrap/dist/js/bootstrap.js'

export default {
  name: 'NavBar',
  props: {
    msg: String
  },
  components: {
     ChgPasswd, ShowVersion 
  },
  data() {
    return {
        callswap : 0, 
        interval : null
    }
  },
  computed: {
    current_swap() {
        return this.$store.getters.active_swap ;
    },
    userlogin() {
        return this.$store.state.email ;
    },
    swaplist() {
      let swaplist = this.$store.getters.getswap_list ;
      if (! swaplist) 
          return { "name":"NOSWAP", "pswline":0, "state":"off" } ;
      return swaplist ;
    }
  },
  methods: {
    showversion(event) {
        let modalid = 'MODALV01' ;
        let divmodal = document.getElementById( modalid ) ;
        let myModal = new bootstrap.Modal( divmodal, { backdrop : false }) ;

        divmodal.style.top =   (event.clientY + 50) + 'px' ;
        divmodal.style.left =  (event.clientX + 20) + 'px' ;
        myModal.show() ;
        return 0 ;
    },
    show_modalpwd(event) {
        let modalid = "MChgPasswd01" ;
        let divmodal = document.getElementById( modalid ) ;
        let myModal = new bootstrap.Modal( divmodal, { backdrop : false }) ;
        divmodal.style.top =  (event.clientY - 50) + 'px' ;
        divmodal.style.left = event.clientX - 350 + 'px' ;
        myModal.show() ;
        return 0 ;
    },
    checkpassword(password) {
      let regex =
/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!%*?&]{8,15}$/;
        return regex.test(password) ;
    },
    changepwd() {
        this.config = this.$store.getters.usermgmt ;
        this.userroles = this.config.userroles ;

        let oldpasswd = this.$refs.MChgPasswd01.oldpasswd ;
        let newpasswd1 = this.$refs.MChgPasswd01.newpasswd1 ;
        let newpasswd2 = this.$refs.MChgPasswd01.newpasswd2 ;

        if ( newpasswd1.length < this.config.passwordlen) {
             return alert ('PASSWORD LENGTH MIN ' + 
                  this.config.passwordlen + ' CHARS') ;
        }
        if (newpasswd1 != newpasswd2 )  
            return alert ("NEW PASSWD and CONFIRMATION not match") ;

        if (this.config.passwordstrength) 
             if (! this.checkpassword(newpasswd1)) {
                  return alert ("Password must contain mix letter, number and special") ;
             }

        this.$store.commit("changepwd", 
            { "user" : this.$store.state.email,
              "oldpasswd" :  oldpasswd ,
              "newpasswd" :  newpasswd1
            }) ;
        this.$refs.MChgPasswd01.reset();
    },
    changeswap(pswline) {
       this.$store.commit("changeswap", pswline) ;	
    },
    logout() { 
        this.$store.commit("logout") ;	
    }
  },
  mounted() {
    if (this.$store.getters.active_swap == 0) 
       this.$store.commit("changeswap", this.$store.getters.controllerid) ;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.proswitch {
    font-size: 10pt;
    color: black;
}
.alignright {
   right : 20px ;
   position: relative ;
}

.alignright2 {
   right : 20px ;
   position: relative ;
}

.alignright3 {
   left : 200px ;
   position: relative ;
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #000000 ;
}

.dropdown-item {
  color : black  ;
}
</style>

// vim:expandtab:smartindent:tabstop=4:softtabstop=4:shiftwidth=4:
